(function () {
  class EddCalculator {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('.edd-calculator__form');
      this.input = root.querySelector('.edd-calculator__input');
      this.message = root.querySelector('.edd-calculator__message');
      this.button = root.querySelector('.edd-calculator__button');
      this.apiUrl = (root.dataset.apiUrl || '').trim();
      if (this.apiUrl.startsWith('/')) {
        this.apiUrl = `${window.location.origin}${this.apiUrl}`;
      }
      this.pickupPincode = root.dataset.pickupPincode || '121004';
      this.weight = parseFloat(root.dataset.weight) || 0.5;
      this.cod = root.dataset.cod === 'true';
      this.deliveryLabel = root.dataset.deliveryLabel || 'Free delivery';
      this.storageKey = 'edd_pincode';
      this.lastCheckedPincode = '';
      this.requestId = 0;
      this.bindEvents();
      this.prefillPincode();
    }

    bindEvents() {
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.checkDelivery();
      });

      this.input.addEventListener('input', () => {
        this.input.value = this.input.value.replace(/\D/g, '').slice(0, 6);

        if (this.input.value.length === 6) {
          this.checkDelivery();
          return;
        }

        this.hideMessage();
      });
    }

    prefillPincode() {
      const saved = localStorage.getItem(this.storageKey);
      if (saved && /^\d{6}$/.test(saved)) {
        this.input.value = saved;
        this.checkDelivery();
      }
    }

    hideMessage() {
      this.message.hidden = true;
      this.message.textContent = '';
      this.message.innerHTML = '';
      this.message.className = 'edd-calculator__message';
    }

    setMessage(text, type) {
      this.hideMessage();
      this.message.hidden = false;
      this.message.textContent = text;
      this.message.className = `edd-calculator__message edd-calculator__message--${type}`;
    }

    setSuccessMessage(deliveryDate) {
      this.message.hidden = false;
      this.message.className = 'edd-calculator__message edd-calculator__message--success';
      this.message.innerHTML =
        `<span class="edd-calculator__delivery-badge">${this.deliveryLabel}</span>` +
        `<span class="edd-calculator__separator" aria-hidden="true"> | </span>` +
        `<span class="edd-calculator__delivery-date">By ${deliveryDate}</span>`;
    }

    async checkDeliveryViaApi(pincode) {
      const requestId = ++this.requestId;
      this.button.disabled = true;

      try {
        const params = new URLSearchParams({
          pincode,
          pickup_pincode: this.pickupPincode,
          weight: String(this.weight),
          cod: this.cod ? '1' : '0'
        });

        const response = await fetch(`${this.apiUrl}?${params.toString()}`);

        if (!response.ok) {
          throw new Error(`API request failed (${response.status})`);
        }

        const data = await response.json();

        if (requestId !== this.requestId) {
          return;
        }

        if (!data.success) {
          throw new Error(data.message || 'Unable to check delivery for this pincode.');
        }

        const label = data.delivery_label || data.delivery_date;
        this.lastCheckedPincode = pincode;
        this.setSuccessMessage(label);
      } catch (error) {
        if (requestId !== this.requestId) {
          return;
        }

        this.setMessage('Unable to fetch live delivery date. Please try again.', 'error');
      } finally {
        if (requestId === this.requestId) {
          this.button.disabled = false;
        }
      }
    }

    checkDelivery() {
      const pincode = this.input.value.trim();

      if (!/^[1-8][0-9]{5}$/.test(pincode)) {
        if (pincode.length === 6) {
          this.setMessage('Please enter a valid 6-digit Indian pincode.', 'error');
        }
        return;
      }

      if (pincode === this.lastCheckedPincode && !this.message.hidden) {
        return;
      }

      localStorage.setItem(this.storageKey, pincode);

      if (this.apiUrl) {
        this.checkDeliveryViaApi(pincode);
      }
    }
  }

  function initCalculators() {
    document.querySelectorAll('.edd-calculator').forEach((root) => {
      if (!root.dataset.initialized) {
        root.dataset.initialized = 'true';
        new EddCalculator(root);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCalculators);
  } else {
    initCalculators();
  }

  document.addEventListener('shopify:section:load', initCalculators);
})();
